import getFeedUrl from '../../lib/settings/getFeedUrl';

import {
  loadPodcastEpisode,
  loadPodcastEpisodesWithNavFields,
  isEpisodeNotFoundError,
} from './EpisodePage.feedApi';

import stringifyError from '../../lib/utils/stringifyError';

import { IRoutePageGetInitialPropsArgs } from '../../lib/router/types';
import { IEpisodePageInitialProps } from './types';
import { BiEvent } from '../../lib/bi/types';
import { WidgetPage } from '@wix/podcasts-common/dist/widget';

async function getInitialProps({
  isServer,
  res,
  context,
  params,
}: IRoutePageGetInitialPropsArgs): Promise<IEpisodePageInitialProps> {
  const { settings, biLogger, biTransaction, config } = context;

  const feedUrl = getFeedUrl(settings, config.defaultFeedUrl);

  const transaction = biTransaction.start(BiEvent.FEED_LOAD_REQUESTED);
  const biParams = {
    feedId: feedUrl,
    pageType: WidgetPage.EPISODE,
    isServerSide: isServer,
    correlationId: transaction.id,
  };

  try {
    void biLogger.feedLoadRequested(biParams);

    const [episode, episodes] = await Promise.all([
      loadPodcastEpisode({ url: feedUrl, id: params.id }),
      loadPodcastEpisodesWithNavFields({ url: feedUrl }),
    ]);

    const episodeIndex = episodes.findIndex((e) => e.id === episode.id);

    void biLogger.feedLoadCompleted({
      ...biParams,
      loadTime: biTransaction.end(transaction).duration,
      success: true,
    });

    return {
      episode,
      prevEpisode: episodes[episodeIndex + 1],
      nextEpisode: episodes[episodeIndex - 1],
    };
  } catch (error) {
    void biLogger.feedLoadCompleted({
      ...biParams,
      loadTime: biTransaction.end(transaction).duration,
      success: false,
      errorType: stringifyError(error),
    });

    if (isEpisodeNotFoundError(error)) {
      error.statusCode = 404;
    }

    if (res && error.statusCode) {
      res.statusCode = error.statusCode;
    }

    console.error(error);

    return { error };
  }
}

export default getInitialProps;
